import React, { useState, useContext, useEffect } from "react";
import InputField from "../Components/InputField"; //importing text input filed
import HoverButton from "../Components/HoverButton"; // adding hover styling button
import logo from "../assets/logo.png";
import loginbg from "../assets/loginbg.png";
import { useNavigate } from "react-router-dom"; //navigating between screens using usenavigate hook
import { getLogin, genOTP } from "../Services/UserLoginService"; //importing api exe fucntion
import Loader from "../Components/Loader"; //loader message
import { ToastContext } from "../utils/ToastContext"; // display toast message using context mandatory
import { useDispatch } from "react-redux"; //sendign login info to sidebar and others screns.
import {
  resetMFATime,
  setMFAEmail,
  setShowMFA,
} from "../utils/redux/reducer/mfaSlice";
import { TbLockExclamation } from "react-icons/tb";
import { setUserDetails } from "../utils/redux/reducer/userSlice";

const Login = () => {
  const [passwordShown, setPasswordShown] = useState(false); //hide and show password
  const [showForgotPassword, setShowForgotPassword] = useState(false); // hide and show forgot password screen
  const [username, setUsername] = useState(""); //setting username
  const [password, setPassword] = useState(""); //setting password
  const [email, setEmail] = useState(""); //email for forgot password
  const [oldPassword, setOldPassword] = useState(""); //old password for forgot password
  const [newPassword, setNewPassword] = useState(""); //new password for forgot password
  const [loader, setLoader] = useState(false); // show and hide to display loader
  const { showToast } = useContext(ToastContext); // context hook to display the toast meassage
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    document.title = "Login";
  }, []);

  // Effect hook to listen for window resize events
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    // Cleanup function to remove the event listener
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const navigate = useNavigate(); //navigate

  const dispatch = useDispatch(); //sending data to redux

  //function for hide and show password
  const togglePassword = () => setPasswordShown(!passwordShown);
  //fucntion for hide and show forgot password screen
  const toggleForgotPassword = () => setShowForgotPassword(!showForgotPassword);

  //login button function
  const handleLogin = async () => {
    setLoader(true);
    if (!username || !password) {
      //check fileds empty or not
      showToast("Oops You Miss Something!", "error"); //display toast msg
      setLoader(false); //dismiss loader
    } else {
      //check email format
      const regex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
      if (!regex.test(username)) {
        setLoader(false);
        showToast("Improper Email!", "error");
      } else {
        try {
          localStorage.setItem("ameyoPass", password);

          const payload = {
            email: username,
            password: password,
          };

          //calling the api
          const loginData = await getLogin(payload);
          setLoader(true);
          if (
            loginData.data.message === "IP verified" &&
            loginData.success === true &&
            loginData.message === "Success"
          ) {
            const userData = loginData;
            dispatch(setUserDetails(userData.data));
            localStorage.setItem("ameyoAutoLogin", "true");
            localStorage.setItem("accessToken", userData.data.accessToken);
            localStorage.setItem("refreshToken", userData.data.refreshToken);
            //navigating to dashbopard
            setLoader(false); //dismiss loader
            showToast("Login Successfully!", "success");
            dispatch(setMFAEmail(null));
            dispatch(setShowMFA(false));
            if (userData?.data?.UserDetails?.role === "Sales User") {
              navigate("/smartview");
            } else {
              navigate("/dashboard");
            }
          } else if (
            loginData.message === "Success" &&
            loginData.success === true
          ) {
            try {
              const generateOTP = await genOTP({ email: loginData.data.email });
              if (
                generateOTP.message === "Success" &&
                generateOTP.success === true
              ) {
                dispatch(setMFAEmail(loginData.data.email));
                dispatch(setShowMFA(true));
                setLoader(false);
                showToast("OTP has been sent", "success");
                navigate("/mfa");
              }
            } catch (error) {
              setLoader(false);
              showToast("Error while generating OTP", "error");
              dispatch(setMFAEmail(null));
              dispatch(setShowMFA(false));
              dispatch(resetMFATime());
            }
          } else {
            setLoader(false);
            showToast(loginData.message, "error");
            dispatch(setMFAEmail(null));
            dispatch(setShowMFA(false));
            dispatch(resetMFATime());
          }
        } catch (error) {
          setLoader(false);
          if (error?.response?.data?.success) {
            showToast(error?.response?.data?.message, "error");
          } else {
            showToast("Oops Something Went Wrong!", "error");
          }
          dispatch(setMFAEmail(null));
          dispatch(setShowMFA(false));
          dispatch(resetMFATime());
        }
      }
    }
  };

  // on form submit will check which function to call
  const handleFormSubmit = (e) => {
    e.preventDefault(); // Prevents the default form submission behavior
    handleLogin();
  };

  return (
    <div>
      {loader === true ? <Loader /> : null}
      <div
        style={{
          ...styles.container,
          flexDirection: windowWidth > 768 ? "row" : "column",
        }}
      >
        {/* displaying forms on left side of screen */}
        <div style={styles.left}>
          <img src={logo} alt="Company Logo" style={styles.logo} />
          {/* displaying forms from here */}
          <form onSubmit={handleFormSubmit} autoComplete="off">
            {showForgotPassword ? (
              // forgotpassword form start from here
              <>
                <p style={styles.title}>Forgot Password</p>
                <div style={styles.inputContainers}>
                  <p style={styles.userTitle}>Email Address*</p>
                  <div>
                    <InputField
                      type="text"
                      iconName="MdEmail"
                      placeholder="Email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                  <p style={styles.userTitle}>Old Password*</p>
                  <div>
                    <InputField
                      type="text"
                      iconName="TiLockClosed"
                      placeholder="Old password"
                      value={oldPassword}
                      onChange={(e) => setOldPassword(e.target.value)}
                    />
                  </div>
                  <p style={styles.userTitle}>New Passowrd*</p>
                  <div>
                    <InputField
                      type="text"
                      iconName="TiLockClosed"
                      placeholder="New password: max 12 characters"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                    />
                  </div>
                  {/* displaying forgot password button */}
                  <div
                    style={{ marginTop: "25px", display: "grid", gap: "20px" }}
                  >
                    <HoverButton
                      type="submit"
                      text="Reset Password"
                      iconName="IoChevronForwardCircleOutline"
                    />
                    <HoverButton
                      onClick={toggleForgotPassword}
                      text="Back to Login"
                      iconName="IoChevronBackCircleOutline"
                    />
                  </div>
                  {/* going back to login screen */}
                </div>
              </>
            ) : (
              // login form starts from here
              <>
                <p style={styles.title}>Login</p>
                <div style={styles.inputContainers}>
                  <div>
                    <p style={styles.userTitle}>Email Address</p>
                    <InputField
                      type="text"
                      iconName="IoPersonCircleOutline"
                      placeholder="Username/ Email"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                    />
                  </div>
                  <div>
                    <p style={styles.userTitle}>Password</p>
                    <InputField
                      type={passwordShown ? "text" : "password"}
                      iconName={passwordShown ? "IoEye" : "IoEyeOff"}
                      placeholder="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      onClickIcon={togglePassword}
                    />
                  </div>
                  <div style={styles.buttonContainer}>
                    <HoverButton
                      // onClick={handleLogin}
                      text="Login"
                      iconName="IoMdLogIn"
                      type="submit"
                    />
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "2px",
                        cursor: "pointer",
                        color: "#EC181E",
                      }}
                      onClick={() => navigate("/forgot-password")}
                    >
                      <TbLockExclamation style={{ fontSize: "18px" }} />
                      <p style={{ fontSize: "15px" }}>Forgot Password ?</p>
                    </div>
                  </div>
                </div>
              </>
            )}
          </form>
        </div>
        <div style={styles.right}>
          <img src={loginbg} alt="Background" style={styles.loginbg} />
          <p
            style={{
              color: "#06152B",
              fontSize: "20px",
              fontWeight: "bold",
              textAlign: "center",
              margin: 0,
              // padding: 10,
              width: "40%",
            }}
          >
            "Transform leads into opportunities, opportunities into
            achievements, Your drive today fuels your success tomorrow."
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;

const styles = {
  container: {
    backgroundColor: "#FFFFFF",
    display: "flex",
    height: "100vh",
    flexWrap: "wrap",
  },
  logo: {
    maxHeight: "123px",
  },
  loginbg: {
    minHeight: "100px",
    minWidth: "10rem",
    maxWidth: "35rem",
    width: "100%",
    objectFit: "cover",
  },
  right: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    background: "#F1F4FA",
    padding: "10px",
  },
  left: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    minWidth: "425px",
    padding: "30px",
  },
  title: {
    color: "#06152B",
    fontSize: "25px",
    fontWeight: "600",
  },
  inputContainers: {
    justifyContent: "center",
    display: "flex",
    flexDirection: "column",
  },
  buttonContainer: {
    marginTop: "20px",
    justifyContent: "center",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  userTitle: {
    color: "#06152B",
    fontSize: "16px",
    fontWeight: "500",
  },
  forgotPassword: {
    textAlign: "end",
    width: "100%",
    margin: "20px 0",
    color: "#3A36DB",
    cursor: "pointer",
  },
};
